import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './assets/css/style.css';
import './assets/css/normalize.css';
import LeftSide from './LeftSide';
import RightSide from './RightSide';

class App extends Component {
  render() {
    return (
       <div className="wrap justify-content-start" >
       <LeftSide> </LeftSide>
       <RightSide/>
       </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js